<template>
  <div>
    <div v-if="vacancyList.id">
      <div class="vacancy-list-links">
        <div class="vacancy-list-links__item">
          <span @click.stop.prevent="copyTestingCode">
            <button class="vacancy-list-links__link">
              <svg
                width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM15 5L21 11V21C21 22.1 20.1 23 19 23H7.99C6.89 23 6 22.1 6 21L6.01 7C6.01 5.9 6.9 5 8 5H15ZM14 12H19.5L14 6.5V12Z" fill="#757575" />
              </svg>
              {{ $t('copy') }}
            </button>
          </span>
          <input id="testing-code" type="hidden" :value="link">
        </div>
        <div class="vacancy-list-links__item">
          <div v-if="webShareApiSupported">
            <span @click="shareViaWebShare">
              <button class="vacancy-list-links__link">
                <svg
                  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5C21 3.34 19.66 2 18 2C16.34 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.35C15.11 18.56 15.08 18.78 15.08 19C15.08 20.61 16.39 21.92 18 21.92C19.61 21.92 20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08Z" fill="#757575" />
                </svg>
                {{ $t('share') }}
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopyLinks',
  props: {
    vacancyList: {
      type: Object,
      required: true,
    },
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      linkCopied: false,
    };
  },
  computed: {
    webShareApiSupported() {
      return navigator.share;
    },
    link() {
      return window.location.href;
    },
  },
  methods: {
    copyTestingCode() {
      const testingCodeToCopy = document.querySelector('#testing-code');
      testingCodeToCopy.setAttribute('type', 'text');
      testingCodeToCopy.select();

      document.execCommand('copy');

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
      this.$toast.info(this.$t('linkCopied'));
    },
    shareViaWebShare() {
      navigator.share({
        title: this.$t('shareTitle', { companyName: this.company.name }),
        text: this.$t('shareDescription', { companyName: this.company.name }),
        url: this.link,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .vacancy-list-links {
    display: flex;
    align-items: center;
    background: #FFFFFF;
    padding: 1.125rem 1.375rem;
    box-shadow: 0 2px 0.5rem rgba(0, 0, 0, 0.16);
    border-radius: 0.625rem;
    margin-bottom: 1.25rem;
    &__item {
      max-width: 50%;
      &:first-child {
        margin-right: 3.125rem;
      }
    }
    &__link {
      display: flex;
      align-items: center;
      text-align: left;
      font-size: 0.875rem;
      font-weight: 400;
      line-height: 1.43;
      color: #0A82D9;
      svg {
        min-width: 1.5rem;
        margin-right: 0.625rem;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .vacancy-list-links {
      padding: 1.125rem 1rem;
      &__item:first-child {
        margin-right: 1.875rem;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .vacancy-list-links {
      &__item {
        width: 50%;
        &:first-child {
          margin-right: 0.9375rem;
        }
      }
      &__link {
        display: flex;
        align-items: center;
        font-size: 0.75rem;
        line-height: 1.25;
        svg {
          min-width: 1.25rem;
        }
      }
    }
  }
</style>

<i18n locale="en" lang="yaml">
copy: Copy link
share: Share link
linkCopied: Link copied
shareDescription: 'Check out this selection of jobs at {companyName}'
shareTitle: 'Selection of jobs at {companyName}'
</i18n>

<i18n locale="ru" lang="yaml">
copy: Скопировать ссылку
share: Поделиться ссылкой
linkCopied: Ссылка скопирована
shareDescription: 'Посмотри эту подборку вакансий в компании {companyName}'
shareTitle: 'Подборка вакансий компании {companyName}'
</i18n>
